import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackSearchSortedParameters extends TrackEventBaseParameters<null, "sort_type"> {}

const trackSearchSorted = (parameters: TrackSearchSortedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "search_sorted", ...parameters }, options);
};

export default trackSearchSorted;
